import React, { useState, useEffect, useRef } from "react";

import "./predictionBox.css";

// IMAGE IMPORTING
import TimeIcon from "../../../assets/icon/Time.svg";
import teamImage from "../../../utilities/constants.json";
import Moment from "moment";
import { predictGameAnswer } from "../../../services/questionApi";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import { Link } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { FixtureData, QuestionData } from "../../../actions";
import PredictionCountDown from "./PredictionCountDown";
import { useUpdateQuestions } from "../../../hooks/useUpdateQuestions";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const imageUrl = teamImage.team_image;

const PredictionBoxRadio = (prop) => {
  const [openTimeOut, setOpenTimeOut] = useState(false);
  const [openPleaseLogin, setOpenPleaseLogin] = useState(false);

  const { updateQuestions } = useUpdateQuestions();

  const fixtureUrl = prop?.data?.fixture?.fix_url;

  const handleTimeOutClose = () => {
    setOpenTimeOut(false);
  };

  const handlePleaseLoginClose = () => {
    setOpenPleaseLogin(false);
  };

  const [teamOneActive, setTeamOneActive] = useState(false);

  const index = parseInt(prop.index) + 1;

  const time = React.useMemo(
    () =>
      new Date(
        Moment(prop?.data?.que_time_qatar_string, "YYYY-MM-DD HH:mm:ss").format(
          "MMM DD, YYYY HH:mm:ss",
        ),
      ).getTime(),
    [prop?.data?.que_time_qatar_string],
  );

  const [answer, setAnswer] = useState();
  const [timeFlag, setTimeFlag] = useState(false);

  useEffect(() => {
    setTimeFlag(false);
    setDefaultData();
  }, [prop?.data?._id?.$oid, prop?.data?.user_prediction?.answer]);

  function setDefaultData() {
    let currentDate = Moment.utc()
      .utcOffset(teamImage.timeOffset)
      .format("YYYY-MM-DDTHH:mm:ss");
    let stime = new Date(
      Moment(prop.data.que_time_qatar_string, "YYYY-MM-DD HH:mm:ss").format(
        "MMM DD, YYYY HH:mm:ss",
      ),
    ).getTime();
    if (stime < new Date(currentDate).getTime()) {
      setTimeFlag(true);
    }
    if (prop?.data?.que_answer || prop?.data?.user_prediction?.answer) {
      setAnswer(prop?.data?.que_answer || prop?.data?.user_prediction?.answer);
    } else {
      setAnswer("");
    }
  }
  const teamOneClick = (e, item) => {
    let currentDate = Moment.utc()
      .utcOffset(teamImage.timeOffset)
      .format("YYYY-MM-DDTHH:mm:ss");
    if (localStorage.webKey) {
      if (time > new Date(currentDate).getTime()) {
        setAnswer(item);
        prop.updateAnswers({
          fixture_id: prop.data.fixture._id["$oid"],
          question_id: prop.data._id["$oid"],
          answer: item,
        });

        setTeamOneActive(!teamOneActive);
      } else {
        setTimeFlag(true);

        setOpenTimeOut(true);
      }
    } else {
      setOpenPleaseLogin(true);
    }
  };

  function predictAnswer() {
    if (answer) {
      predictGameAnswer({
        question_id: prop.data._id["$oid"],
        answer: answer,
        fixture_id: prop.data.fixture._id["$oid"],
      })
        .then((res) => {
          if (res.data.status == 1) {
            updateQuestions(prop.data._id["$oid"], answer);
          } else {
            if (res.data.status == 101) {
              localStorage.clear();
              setOpenPleaseLogin(true);
            } else {
              if (res.data.message == "Time out!") {
                setOpenTimeOut(true);
              }
            }
          }
        })
        .catch(() => {});
    }
  }

  const handleOpen = (teamUrl) => {
    if (!fixtureUrl && !teamUrl) return;

    let url = "";

    let currentDate = Moment.utc()
      .utcOffset(teamImage.timeOffset)
      .format("YYYY-MM-DDTHH:mm:ss");

    if (time > new Date(currentDate).getTime()) url = teamUrl;
    else url = fixtureUrl || teamUrl;

    if (!!url) window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div key={prop?.data?._id?.$oid} className="predictionBox">
      <div className="predictionBox-grid">
        <div className="predictionBox-item">
          <div className="predictionBox-itemWrapper">
            <div className="predictionBox-topSection">
              <div className="predictionBox-top-part1">
                <div className="predictionBox-groupTime-wrapper">
                  <h6 className="groupText">Qn No. {index}</h6>
                </div>
                <div className="predictionBox-points-wrapper">
                  <p className="predictionBox-points">
                    {prop.data.que_points} Points
                  </p>
                </div>
                  {!prop.isPostponed &&  
                (<div className="predictionBox-remainingTime-wrapper">
                  <div className="predictionBox-timeImg">
                    <img
                      className={
                        time >
                        new Date(
                          Date.parse(
                            Moment.utc()
                              .utcOffset(teamImage.timeOffset)
                              .format("YYYY-MM-DD HH:mm:ss"),
                          ),
                        ).getTime()
                          ? "time-icon"
                          : "time-icon-selected"
                      }
                      src={TimeIcon}
                      alt=""
                    />
                  </div>
                  <PredictionCountDown timeString={prop?.data?.que_time_qatar_string}
                  />
                </div>)}
              </div>
              <div className="predictionBox-top-part2">
                <div className="predictionBox-questionWrapper">
                  <p className="predictionBox-question">
                    {localStorage.language == "en"
                      ? prop.data.question
                      : prop.data.que_malayalam}
                    <br />
                  </p>
                </div>
              </div>
            </div>
            <div className="predictionBox-bottomSection">
              <div className="row d-flex justify-content-center align-items-baseline px-1 p-lg-0">
                <div className="col-2 d-flex justify-content-center align-items-center px-1 px-lg-3">
                  <div
                    className={
                      fixtureUrl || prop.data.fixture.fix_team_a?.team_url
                        ? "predictionBox-teamOne"
                        : "predictionBox-inactive"
                    }
                    onClick={() =>
                      handleOpen(prop.data.fixture.fix_team_a?.team_url)
                    }
                  >
                    <img
                      src={imageUrl + prop.data.fixture.fix_team_a.team_flag}
                      alt="Team 1"
                    />
                  </div>
                </div>
                <div className="col-8 d-flex justify-content-center">
                  <div className="predictionBox-predictionWrapper">
                    {/* <p className="topText">Tap to predict</p> */}
                    <div className="predictionBox-prediction-button">
                      {/* <button onClick={handleClick} className="team1">Qatar</button> */}

                      {prop.data.que_answer_option.map((item, key) => {
                        return (
                          <button
                            key={key}
                            // title={key}
                            onClick={(e) => teamOneClick(e, item)}
                            className={
                              answer === item ? "team1 selected-team1" : "team1"
                            }
                          >
                            {item}
                          </button>
                        );
                      })}
                    </div>

                    <p className="bottomText">
                      {prop.data.user_prediction
                        ? "Your prediction :" + prop.data.user_prediction.answer
                        : timeFlag || prop.data.que_answer
                          ? "Oops! You missed this prediction "
                          : "Tap to choose your prediction"}
                    </p>
                  </div>
                </div>
                <div className="col-2 d-flex justify-content-center align-items-center px-1 px-lg-3">
                  <div
                    className={
                      fixtureUrl || prop.data.fixture.fix_team_b?.team_url
                        ? "predictionBox-teamTwo"
                        : "predictionBox-inactive"
                    }
                    onClick={() =>
                      handleOpen(prop.data.fixture.fix_team_b?.team_url)
                    }
                  >
                    <img
                      src={imageUrl + prop.data.fixture.fix_team_b.team_flag}
                      alt="Team 2"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <PleaseLoginModal /> */}
      </div>
      <div className="timeOverModal">
        <Dialog
          open={openTimeOut}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleTimeOutClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <div className="timeOverModal-wrapper">
            <div className="timeOverModal-header">
              <h2>Time Over !!!</h2>
            </div>
            <div className="timeOverModal-content">
              <p>You can't change the prediction.</p>
              {/*<p>You cant the change the prediction now.</p>*/}
              {/*<p>You cant the change the prediction now.</p>*/}
            </div>

            <div className="timeOverModal-button-wrapper">
              <Button
                onClick={handleTimeOutClose}
                className="timeOverModal-login-btn"
              >
                GOT IT
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
      <div className="pleaseLoginModal">
        <Dialog
          open={openPleaseLogin}
          TransitionComponent={Transition}
          keepMounted
          onClose={handlePleaseLoginClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <div className="pleaseLoginModal-wrapper">
            <div className="pleaseLoginModal-header">
              <h2>Not Logged In!</h2>
            </div>
            <div className="pleaseLoginModal-content">
              <p>Please login/register to start predicting.</p>
            </div>

            <div className="pleaseLoginModal-button-wrapper">
              <Link to="/mobile-login">
                <Button className="pleaseLoginModal-login-btn">LOGIN</Button>
              </Link>
              <Link to="/mobile-register">
                <Button className="pleaseLoginModal-register-btn">
                  REGISTER
                </Button>
              </Link>
            </div>
          </div>
        </Dialog>
      </div>
      <ToastContainer />
    </div>
  );
};

export default PredictionBoxRadio;
